<template>
    <span
        class="inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs font-semibold"
        :class="badgeClass"
    >
        <AppIcon :icon="badgeIcon" class="h-3.5 w-3.5" />
        {{ badgeLabel }}
    </span>
</template>

<script>
export default {
    name: "RoomValidationBadge",
    props: {
        state: {
            type: String,
            default: "incomplete", // complete | incomplete | error | uploading | saved
        },
    },
    computed: {
        badgeLabel() {
            const labels = {
                complete: this.$t("checkout.badge.complete"),
                incomplete: this.$t("checkout.badge.incomplete"),
                error: this.$t("checkout.badge.error"),
                uploading: this.$t("checkout.badge.uploading"),
                saved: this.$t("checkout.badge.saved"),
            };
            return labels[this.state] || this.$t("checkout.badge.incomplete");
        },
        badgeIcon() {
            const icons = {
                complete: "mdi:check-circle",
                incomplete: "mdi:alert-circle-outline",
                error: "mdi:close-circle",
                uploading: "mdi:cloud-upload-outline",
                saved: "mdi:content-save-check-outline",
            };
            return icons[this.state] || "mdi:alert-circle-outline";
        },
        badgeClass() {
            const classes = {
                complete: "bg-green-100 text-green-700",
                incomplete: "bg-gray-100 text-gray-700",
                error: "bg-red-100 text-red-700",
                uploading: "bg-blue-100 text-blue-700",
                saved: "bg-emerald-100 text-emerald-700",
            };
            return classes[this.state] || "bg-gray-100 text-gray-700";
        },
    },
};
</script>
